<div class="flex flex-col justify-center items-stretch max-w-full py-4">
  <ng-container *ngIf="showForm">
    <app-edit-attribute-form [form]="form"></app-edit-attribute-form>
    <div class="flex flex-row justify-center items-center">
      <button
        mat-raised-button
        color="primary"
        (click)="save()"
        testId="edit-attribute-save"
      >
        Save
      </button>
      <button
        mat-raised-button
        (click)="cancel()"
        testId="edit-attribute-cancel"
      >
        Cancel
      </button>
    </div>
  </ng-container>
</div>
